<template>
  <chart-template></chart-template>
</template>
<script>
  import template from "@/services/components/ScoreChart/template.vue";
  export default {
    name: "score-chart",
    components: {
      "chart-template": template
    }
  }
</script>
